import $ from 'jquery';

$(document).ready(function(){
    function docountdown ()
    {
        $('.fig').each(function() {
            if ( $(this).attr('data-fig').indexOf(',') > 0 ) {
                let decimals = $(this).attr('data-fig').length - 1- $(this).attr('data-fig').indexOf(',');
                $(this).attr('data-decimals', decimals);
                $(this).attr('data-fig', $(this).attr('data-fig').replace(',',''));
            }
            if ( $(this).attr('data-fig').indexOf('.') > 0 ) {
                $(this).addClass('thousandSep');
                $(this).attr('data-fig', $(this).attr('data-fig').replace('.',''));
            }
            function filterSeperators (fig, count){
                if (fig.hasClass('thousandSep')){
                    if (Math.floor(count.countNum/1000) == 0) {
                        fig.text(Math.floor(count.countNum % 1000));
                    }
                    else {
                        let to3places = Math.floor(count.countNum % 1000)
                        if (to3places < 10 ) {to3places= '00'+to3places}
                        else if (to3places < 100) {to3places= '0'+to3places}
                        fig.text(Math.floor(count.countNum/1000) +'.'+ to3places);
                    }
                }
                else if (fig.attr('data-decimals') != undefined) {
                    let decimals = parseInt(fig.attr('data-decimals'));
                    fig.text(Math.floor(count.countNum / Math.pow(10, decimals)) + ','+ Math.floor(count.countNum % Math.pow(10, decimals)));
                }
                else {
                    fig.text(Math.floor(count.countNum));
                }
            }

            if ($.isNumeric($(this).html()) && !$(this).closest(".fig").closest('.count').hasClass("done"))
            {
                let $this = $(this);
                let countTo = parseInt($this.attr("data-fig"));
                let offset = $(window).scrollTop() + $(window).height()/1.2;
                if ( $this.offset().top <= offset && !$this.closest('.count').hasClass("anim"))
                {
                    
                    $this.closest('.count').addClass("anim");
                    $({ countNum: 0}).animate({
                    countNum: countTo
                    },
                    {
                        duration: 3000,
                        easing:'linear',
                        step: function() {
                            filterSeperators($this, this);

                        },
                        complete: function() {
                            filterSeperators($this, this);
                            $this.closest('.count').removeClass("anim");
                            $this.closest(".fig").closest('.count').addClass("done");
                        }
                    });
                }
            }
        });
    }
  
    if ($('.fig').length) 
    {
        $(window).on("scroll", function(){
      docountdown(); 
        });
    
        $(window).on("load", function(){
      docountdown();
        });
    }
});



